export const JustifiPaymentPortal = () => {
  console.warn('This is an unimplemented file.');

  return <div>JustifiPortal</div>;
};
